document.addEventListener("DOMContentLoaded", (event) => {
  // Menu customization for heading click/view all integration
  document.querySelectorAll('.mega-menu__column').forEach(column => {
    const headingEl = column.querySelector('.mega-menu__column-heading');
    const viewAllLink = Array.from(column.querySelectorAll('.mega-menu__column-list-link'))
      .find(link => link.textContent.trim().toLowerCase() === 'view all');
  
    if (headingEl && viewAllLink) {
      const href = viewAllLink.getAttribute('href');
      const linkedHeading = document.createElement('a');
      linkedHeading.href = href;
      linkedHeading.className = headingEl.className;
      linkedHeading.textContent = headingEl.textContent.trim();
      headingEl.replaceWith(linkedHeading);
      /* REMOVING PER PF / 09.22.26 viewAllLink.closest('li').style.display = 'none'; */
    }
  });

  // Menu special styling/badgification for "NEW - "
  const newLinks = Array.from(document.querySelectorAll('a.mega-menu__column-list-link, .menu-drawer__mega-menu a')).filter(link =>
    link.textContent.trim().startsWith('NEW - ')
  );
  
  newLinks.forEach(link => {
    const fullText = link.textContent.trim();
    const restOfText = fullText.replace(/^NEW\s*-\s*/, '');

    link.style.fontFamily = "'Rift-Medium', sans-serif";
    // link.style.fontSize = '17.6px';

    link.innerHTML = ''; // Clear existing content

    const wrapperSpan = document.createElement('span');
    wrapperSpan.style.display = 'flex';
    wrapperSpan.style.alignItems = 'center';
    wrapperSpan.style.background = 'none';
    wrapperSpan.style.gap = '8px';

    const newSpan = document.createElement('span');
    newSpan.textContent = 'NEW';
    newSpan.style.color = '#FFFFFF';
    newSpan.style.background = '#007BB8';
    newSpan.style.fontFamily = 'Rift-Bold';
    newSpan.style.padding = '2px 8px';
    newSpan.style.borderRadius = '4px';
    newSpan.style.fontSize = '0.85em';
    newSpan.style.whiteSpace = 'nowrap';

    const textWrapper = document.createElement('span');
    textWrapper.classList.add('link-hover-line');
    textWrapper.textContent = restOfText;

    wrapperSpan.appendChild(newSpan);
    wrapperSpan.appendChild(textWrapper);
    link.appendChild(wrapperSpan);
  });
  
  // Swatch customization for images
  document.querySelectorAll('label.color-swatch').forEach((label) => {
    const style = label.getAttribute('style');
    const match = style.match(/--swatch-color:\s*((?:https?:\/\/|\/\/)[^\s;]+)/);
    if (match && match[1]) {
      const rawUrl = match[1];
      // console.log(rawUrl);
      label.style.setProperty('--swatch-color', `url(${rawUrl})`);
    }
  });

  // Run swatch updates for quickAdd / AJAX events
  const buttons = document.querySelectorAll('button[id^="quick-add"]');
  buttons.forEach(button => {
    button.addEventListener('click', () => {
      setTimeout(() => { waitForSwatches(document.querySelector('.quick-add-modal__content-wrapper')); }, 1000);
    });
  });

  /* const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType === 1 && node.tagName.toLowerCase() === "quick-add-modal") {
          handleQuickAddModal(node);
        }
      }
    }
  });

  function handleQuickAddModal(modal) {
    waitForSwatches(modal);
  }

  observer.observe(document.body, { childList: true, subtree: true }); */

  // Swatch hover activating click() per AT for collections
  document.querySelectorAll("body.template-collection .js-color-swatches-wrapper").forEach((s) => {
    s.querySelectorAll(".js-color-swatches label").forEach((e) => {
      e.addEventListener("mouseenter", (event) => {
        e.click();
      });
    });
  });

  document.querySelectorAll("body.template-index .popular-products .js-color-swatches-wrapper").forEach((s) => {
    s.querySelectorAll(".js-color-swatches label").forEach((e) => {
      e.addEventListener("mouseenter", (event) => {
        e.click();
      });
    });
  });

  // Collection check for Swiper container
  const swiperContainer = document.querySelector('.featured-collections__swiper.swiper');

  if (swiperContainer && isDesktop()) {
    const swiperInstance = swiperContainer.swiper;

    if (swiperContainer.querySelectorAll('.swiper-slide').length >= 4) {
      swiperInstance.params.slidesPerView = swiperContainer.querySelectorAll('.swiper-slide').length;
      swiperInstance.update();
    }
  }
});

function waitForSwatches(modal, maxRetries = 30) {
  let tries = 0;

  const check = () => {
    const swatches = modal.querySelectorAll("label.color-swatch");

    if (swatches.length > 0) {
      console.log(`Found ${swatches.length} swatches in modal.`);

      swatches.forEach((t) => {
        const styleAttr = t.getAttribute("style");
        const match = styleAttr?.match(/--swatch-color:\s*(https?:\/\/[^\s;]+|\/\/[^\s;]+)/);

        if (match && match[1]) {
          let url = match[1];
          if (url.startsWith("//")) {
            url = window.location.protocol + url;
          }

          /* console.log("Swatch color image:", url); */
          t.style.setProperty("--swatch-color", `url(${url})`);
        }
      });
    } else if (tries < maxRetries) {
      tries++;
      requestAnimationFrame(check); // try again on next frame
    } else {
      console.warn("Swatches not found after max retries.");
    }
  };

  check();
}

/* For quantity discounts / JS Add */
function dbAddToCart(variantId, quantity) { 
  const quantityInput = document.querySelector('.quantity__input');
  if (quantityInput) {
    quantityInput.value = quantity;
    document.querySelector('.quantity__button[name="minus"]').classList.remove('disabled');
  }
  document.querySelector('.product-form__submit').click();
}

function isDesktop() {
  const minWidth = 999;
  const widthOk = window.matchMedia(`(min-width: ${minWidth}px)`).matches;

  const hasFinePointer = window.matchMedia('(pointer: fine)').matches;
  const noTouch = navigator.maxTouchPoints === 0;

  return widthOk && (hasFinePointer || noTouch);
}